import React ,{useState}from 'react'
import './Register.css'
import logo from '../../assets/logo.png'
import { Link } from 'react-router-dom'
import ErrorMsg from '../ErrorMsg/ErrorMsg'
import Navbar from '../Home/Navbar/Navbar'
import { useAuth } from '../../auth/AuthContext'



const Register = (props) => {
    const { signUp, firebaseEnabled } = useAuth()
    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [pass, setPass] = useState('')
    const [confirmPass, setConfirmPass] = useState('')
    const [role, setRole] = useState('client')
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)

    const handleRegister = async () =>{
        if (!firebaseEnabled) {
            setError('Registration is unavailable until Firebase is configured.')
            return
        }
        const adminAllowList = (process.env.REACT_APP_ADMIN_EMAILS || '')
            .split(',')
            .map((value) => value.trim().toLowerCase())
            .filter(Boolean)

        if (!email || !pass) {
            setError('Please enter an email and password.')
            return
        }
        if (role === 'admin' && !adminAllowList.includes(email.toLowerCase())) {
            setError('Admin accounts require an allow-listed email.')
            return
        }
        if (pass !== confirmPass) {
            setError('Passwords do not match.')
            return
        }
        setLoading(true)
        setError('')
        try {
            await signUp({ email, password: pass, name, role })
            props.history.push({ pathname: '/appointment' })
        } catch (err) {
            setError(err.message || 'Unable to create account.')
        } finally {
            setLoading(false)
        }
    }

    const registerByPress = (e) =>{
        if(e.key === 'Enter')
            handleRegister()
      }

    
    return (
        <div className='register'>
            <Navbar/>
            <div className='register-container'>
                <div className='register-form'>
                    <div className='register-info'>
                        <h1>Register</h1>
                        <img src={logo} alt=''></img>
                    </div>
                    <div className='form-container'> 
                    {error !== '' ?  <ErrorMsg info={error}/>
                        
                        : ''}
                        <p>Name:</p>
                        <input type="text"
                            placeholder='Name...'
                            className='form-container-input'
                            name='name'
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />
                        <p>Email:</p>
                        <input type="email" 
                            placeholder='Email...'
                            className='form-container-input'
                            name='email'    
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                        <p>Account Type:</p>
                        <select
                            className='form-container-input form-select'
                            name='role'
                            value={role}
                            onChange={(e) => setRole(e.target.value)}
                        >
                            <option value="client">Client</option>
                            <option value="tech">Tech</option>
                            <option value="admin">Admin</option>
                        </select>
                        <p>Password:</p>
                        <input type="password"
                            placeholder='Password...'
                            className='form-container-input'
                            name='password'
                            value={pass}
                            onChange={(e) => setPass(e.target.value)}
                        />
                        <p>Confirm Password:</p>
                        <input type="password"
                            placeholder='Password...'
                            className='form-container-input'
                            name='confirmPassword'
                            value={confirmPass}
                            onChange={(e) => setConfirmPass(e.target.value)}
                            onKeyPress={(e) => registerByPress(e)}
                        /> 
                        <p className='register-helper'>
                            Admin accounts require an allow-listed email.
                        </p>
                        <div className='reg-btn-div'>
                            <button onClick={handleRegister} className='reg-submit' disabled={loading}>
                                {loading ? 'Creating...' : 'Register'}
                            </button>
                        </div>
                        <div className='new-account-login'>
                            <Link to='/login' className='new-account-link'>
                                Have account? <br/>Login Now!
                            </Link> 
                        </div> 
                    </div>
                </div>
                <div className='register-img'></div>
            </div>  
        </div>
    )
}

export default Register
